<template>
  <div id="cert-search">
    <div class="cert-top">
      <div class="cert-search">
        <!-- <el-row> -->
          <span>证书查询</span>
        <!-- </el-row> -->
        <!-- <el-row> -->
          <el-input placeholder="姓名/英文姓名" v-model="name" class="input-with-select" @keyup.enter.native="handleSearch">
          </el-input>
        <!-- </el-row> -->
        <!-- <el-row> -->
          <el-input placeholder="请输入内容" v-model="searchCode" class="input-with-select">
            <el-select v-model="searchType" slot="prepend" placeholder="请选择">
              <el-option label="证件号" value="idCode"></el-option>
              <el-option label="证书编码" value="code"></el-option>
            </el-select>
          </el-input>
        <!-- </el-row> -->
        <el-button size="mini" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <el-table
      ref="searchResult"
      v-loading="listLoading"
      :key="tableKey"
      :data="result"
      :cell-style="cellStyle"
      :header-cell-style="cellStyle"
      fit
      highlight-current-row
      style="width: 960px;"
      row-key="id">
      <el-table-column label="编号" align="center" >
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" align="center" >
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.projectName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始日期" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.startDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束日期" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.endDate }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.state }}</span>
        </template>
      </el-table-column>
      <el-table-column label="接受人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.donated }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="下载" align="center" class-name="small-padding fixed-width" width="150">
        <template slot-scope="scope">
          <a :href="'/api/certificate/down/' + scope.row.id" target="_blank"><img src="@/assets/pdf.png" width="18" height="23" style=""/></a>
          <!-- <el-button size="mini" type="danger" @click="handleRemove(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div style="height:80px">
    </div>
    <foote />
  </div>
</template>

<script>
// import Vue from 'vue'
// import SearchBar from '@/components/Certificate'
import { certificate } from '@/api'
import foote from './Footer'

export default {
  name: 'certificateResult',
  components: { foote },
  data () {
    return {

      name: '',
      searchType: '',
      searchCode: '',

      expandKeys: [], /** 新增 **/
      tableKey: 0,
      listQuery: {
        page: 1,
        size: 10,
        keyword: this.$route.params.keyword
      },
      listLoading: false,
      result: [],
      total: 0
    }
  },
  methods: {
    handleSearch () {
      this.listLoading = true
      certificate({name: this.name, searchType: this.searchType, searchCode: this.searchCode}).then(response => {
        console.log('response', response)
        if (response && response.data && response.data.success === true) {
          this.result = response.data.data
          this.listLoading = false
        } else if (response && response.data && response.data.success === false) {
          this.listLoading = false
          this.$message({
            type: 'error',
            message: '查询失败'
          })
        }
      })
    },
    cellStyle () {
      return 'background-color: #0d0d0d'
    }
  },
  created () {
    // this.getResult()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route' (to, from) {
      this.listQuery.keyword = to.params.keyword
      this.listQuery.page = 1
      this.listQuery.size = 10
      this.getList()
    }
  }
}
</script>

<style lang="less">
  #cert-search {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-select .el-input {
      width: 130px;

    }
    .cert-top {
      height: 300px;
      width: 600px;
      background: #0d0d0d;
      overflow: hidden;
      .cert-search {
        height: 200px;
        width: 600px;
        background: #0d0d0d;
        margin: 0 auto;
        margin-top: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        span {
          font-size: 20px;
          color: #ff7800;
        }
        .el-input-group {
          width: 100% !important;
        }
        .el-input-group__append {
          background-color: #ff7800 !important;
          color: #fff !important;
        }
        .el-button--mini {
          background-color: #ff7800;
          border-color: #ff7800;
          span {
            color: #fff !important;
            font-size: 12pt;
          }
        }
      }
    }
  }
  .el-table td, .el-table th {
    border-bottom: 1px solid #333 !important;
  }
  .el-table__empty-block {
    background-color: #0d0d0d !important;
  }
  .el-table::before {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/CertificateResult.vue